import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import { useAnalytics } from '@context/analytics.context';
import useFeatureFlag from '@hooks/use-feature-flags';
import styles from './pdp-welcome-voucher-banner.module.scss';

type PdpWelcomeVoucherBannerProps = {
  bannerText: string;
  voucherCode: string;
  closeBanner: () => void;
};

const PdpWelcomeVoucherBanner: React.FC<PdpWelcomeVoucherBannerProps> = ({ bannerText, voucherCode, closeBanner }) => {
  const [isBannerClosing, setIsBannerClosing] = useState(false);
  const { scriptsEventData } = useAnalytics();
  const { sendAnalyticEvent } = useAnalyticEvents('pdp_top_banner');
  const { isSemPDP } = useFeatureFlag();

  useEffect(() => {
    if (scriptsEventData?.isTcEvents1Loaded && scriptsEventData?.isTcEvents7Loaded) {
      sendAnalyticEvent('welcome_offer_view', { label: voucherCode });
    }
  }, [scriptsEventData?.isTcEvents1Loaded, scriptsEventData?.isTcEvents7Loaded]);

  const handleClose = () => {
    setIsBannerClosing(true);
    setTimeout(() => {
      closeBanner();
      sendAnalyticEvent('welcome_offer_close', { label: voucherCode });
    }, 300);
  };

  const { t } = useTranslation('default-layout');
  return (
    <div
      className={clsx(styles.pdpWelcomeVoucherBanner, {
        [styles.hidden]: isBannerClosing,
        [styles.textBackground]: isSemPDP,
      })}
    >
      <div className={styles.pdpWelcomeVoucherBanner__text}>{bannerText}</div>
      <button
        data-cy="pdp-banner-close-button"
        className={styles.pdpWelcomeVoucherBanner__closeBtn}
        type="button"
        onClick={handleClose}
        aria-label="close"
      >
        <Icon name="close-default" />
        <span className="visuallyhidden">{t('MODAL.BUTTON.CLOSE')}</span>
      </button>
    </div>
  );
};

export default PdpWelcomeVoucherBanner;
